import { useDispatch, useSelector } from "react-redux";
import * as Action from "../state/actions/Actions";
import SearchResultItem from "./SearchResultItem";
import { IoClose } from "react-icons/io5";
import { decramentAction, incramentAction } from "../state/actions/Actions";
import type { Dispatch, MouseEvent, SetStateAction } from "react";
import type { RootState } from "../state/Reducers/rootReducer";
import { MdNavigateNext } from "react-icons/md";
import { GrFormPrevious } from "react-icons/gr";
import type { IOptionType } from "InterfacesTypes/interfaces";

const SearchResultCarousel = ({
  setSelected,
  setInputVal,
}: {
  setSelected: Dispatch<SetStateAction<IOptionType | null>>;
  setInputVal: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const dispatch = useDispatch();
  // Hooks
  const { webSiteSearchResults } = useSelector(
    (state: RootState) => state.State
  );
  const { searchResultIndexCount } = useSelector(
    (state: RootState) => state.State
  );

  const increment = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    const tempCount = searchResultIndexCount + 3;

    dispatch(incramentAction(tempCount));
  };

  const decrement = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();

    const tempCount = searchResultIndexCount - 3;
    dispatch(decramentAction(tempCount));
  };

  const showPrevBtn = () => {
    if (searchResultIndexCount <= 0) {
      return false;
    }
    return true;
  };

  const showNextBtn = () => {
    const remainderResult = webSiteSearchResults.length % 3;
    let maxIndex = Math.floor(webSiteSearchResults.length / 3) * 3;
    maxIndex = remainderResult === 0 ? maxIndex - 3 : maxIndex;
    if (maxIndex === searchResultIndexCount) {
      return false;
    }

    if (webSiteSearchResults.length > 3) {
      return true;
    }

    return false;
  };

  const showHelpText = () => {
    const remainderResult = webSiteSearchResults.length % 3;
    let maxIndex = Math.floor(webSiteSearchResults.length / 3) * 3;
    maxIndex = remainderResult === 0 ? maxIndex - 3 : maxIndex;
    if (maxIndex === searchResultIndexCount) {
      return true;
    }
    return false;
  };

  if (webSiteSearchResults.length > 0) {
    return (
      <>
        <div
          className="flex
            flex-col
            !w-[65%]
            !no-underline
            !p-[0.6rem]
            !rounded-[16px]
            !shadow-[0_4px_30px_rgba(0,0,0,0.1)]
            backdrop-blur-[20px]
            border border-[rgba(255,255,255,0.53)]"
        >
          <IoClose
            className="flex place-self-end !w-[1.4rem] !h-[1rem]"
            onClick={() => {
              setSelected(null);
              dispatch(Action.searchInputResetAction());
              setInputVal("");
            }}
          />
          {webSiteSearchResults.length === 1 ? (
            <div className="!text-[rgb(44, 43, 43)] pl-[0.5em]">
              Din sökning ger 1 träff:
            </div>
          ) : (
            <div className="flex justify-between">
              <div className="!text-[rgb(44, 43, 43)] pl-[0.5em]">
                Din sökning ger {webSiteSearchResults.length} träffar:
              </div>{" "}
              {showPrevBtn() ? (
                <div
                  onClick={(e: MouseEvent<HTMLElement>) => decrement(e)}
                  className="hover:!bg-transparent hover:!underline
                   !text-[#2c2b2b]
                  !text-[16px]
                  !border-none
                  !outline-none
                  !bg-transparent
                  cursor-pointer
                  flex
                  !justify-end
                  !pt-0
                  !pr-[20px]
                  "
                >
                  <GrFormPrevious className="!w-[1.2rem] !h-[1.6rem]" />
                  Föregående sida{" "}
                </div>
              ) : null}
              {showNextBtn() ? (
                <div
                  onClick={(e: MouseEvent<HTMLElement>) => increment(e)}
                  className="hover:!bg-transparent hover:!underline
                   !text-[#2c2b2b]
                    !text-[16px]
                    !border-none
                    outline-none
                    !bg-transparent
                    !cursor-pointer   
                    flex
                    justify-end
                    !pt-0
                    !pr-5
                  "
                >
                  Nästa sida
                  <MdNavigateNext className="!w-[1.2rem] !h-[1.6rem]" />
                </div>
              ) : null}
            </div>
          )}
          {webSiteSearchResults
            .slice(searchResultIndexCount, searchResultIndexCount + 3)
            .map((viewItem) => (
              <div key={viewItem.Id}>
                <SearchResultItem
                  title={viewItem.Title}
                  urlObject={viewItem.URL}
                  img={viewItem.SiteImage}
                  protected={viewItem.Protected}
                />
              </div>
            ))}

          {showHelpText() ? (
            <div className="text-[rgb(44, 43, 43)] !mt-[1rem] !mx-[0.5em] !mb-0">
              Hittar du inte det du letar efter? Klicka här för att komma till
              kundtjänst och ställ en fråga.{" "}
              <a
                href="https://logistikportalen.fmv.se/kundtjanst/Sidor/Kundtjanst.aspx"
                target="_blank"
                rel="noreferrer"
              >
                [FMV Kundtjänst Verksamhetsstöd]
              </a>
            </div>
          ) : null}
        </div>
      </>
    );
  }
};

export default SearchResultCarousel;
